import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogContent,
  MatDialogActions,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';
import { SimpleDialog } from '../../models/simple-dialog';

@Component({
  selector: 'app-basic-dialog',
  templateUrl: './basic-dialog.component.html',
  styleUrls: ['./basic-dialog.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatDialogContent, MatDialogActions, MatButtonModule],
})
export class BasicDialogComponent {
  appUIComponent: SimpleDialog;
  constructor(
    public dialogRef: MatDialogRef<BasicDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SimpleDialog,
    public router: Router
  ) {
    this.appUIComponent = data;
    dialogRef.disableClose = true;
  }

  onNoClick(): void {
    this.closeModal();
  }

  navigate(url: string): void {
    if (!url) {
      throw new Error('url is undefined');
    }

    this.closeModal();
    this.router.navigate([url]);
  }

  closeModal(): void {
    this.dialogRef.close();
  }
}
